import localhost from "../../../apis/localhost";
import {
  setSharepointData,
  setSharepointError,
  setSharepointLoading,
} from "../sharepointSlice";
import { CONNECTIVITY_ERROR, SKIP_REDIRECT } from "./constants";
import { handledPolicyError } from "./policyErrors";
import { beginRequest, isCurrentRequest, statusOf } from "./utils";

export const fetchSharepointContent = (item) => async (dispatch, getState) => {
  const requestId = beginRequest(dispatch, getState);
  const props = {
    params: {
      siteHost: item.host,
      sitePath: item.sitePath,
      path: item.filePath,
    },
    paramsSerializer: {
      encode: (param) => encodeURIComponent(param),
    },
    ...SKIP_REDIRECT,
  };

  try {
    dispatch(setSharepointLoading(true));
    dispatch(setSharepointError(null));

    const [folderResponse, filesResponse] = await Promise.all([
      localhost.get("/sharepoint/folders", props),
      localhost.get("/sharepoint/files", props),
    ]);
    const folders = folderResponse.data || [];
    const mappedFolders = folders.map((f) => ({ ...f, id: f.filePath }));

    if (!isCurrentRequest(getState, requestId)) {
      return;
    }

    dispatch(setSharepointData([...mappedFolders, ...filesResponse.data]));
  } catch (error) {
    if (!isCurrentRequest(getState, requestId)) {
      return;
    }
    if (handledPolicyError(dispatch, error)) {
      dispatch(setSharepointData([]));
      return;
    }
    const status = statusOf(error);
    if (status >= 500 && status < 600) {
      dispatch(setSharepointError(new Error(CONNECTIVITY_ERROR)));
    }

    dispatch(setSharepointData([]));
  } finally {
    if (isCurrentRequest(getState, requestId)) {
      dispatch(setSharepointLoading(false));
    }
  }
};
